// extracted by mini-css-extract-plugin
module.exports = {"figure":"CrowdersSmallFigure--figure--2FtpJ","background":"CrowdersSmallFigure--background--2p1rS"};